export const INTEGRATION_TYPE_OPTIONS = [
  { value: 'API', disabled: false },
  { value: 'RPA', disabled: true },
] as const;

export const PROCESS_TYPE_OPTIONS = [
  { value: 'COPARTICIPATION', disabled: false },
  { value: 'CADASTRAL_POSITION', disabled: false },
  { value: 'CARRIER_CADASTRAL_MOVEMENT', disabled: true },
  { value: 'CLIENT_CADASTRAL_MOVEMENT', disabled: true },
  { value: 'PAYROLL', disabled: true },
] as const;

export const CADASTRAL_POSITION_PROCESS_TYPE = 'CADASTRAL_POSITION';

export const REQUEST_STATUS_OPTIONS = [
  'RECEIVED',
  'PROCESSING',
  'COMPLETED',
  'COMPLETED_WITH_ERRORS',
] as const;

export const CADASTRAL_REQUEST_STATUS_OPTIONS = [
  'SUCCESS',
  'ERROR',
] as const;

export const CADASTRAL_INVALID_REQUEST_STATUS = 'ERROR';

export function getRequestStatusOptions(processType: string): readonly string[] {
  if (processType === CADASTRAL_POSITION_PROCESS_TYPE) {
    return CADASTRAL_REQUEST_STATUS_OPTIONS;
  }
  return REQUEST_STATUS_OPTIONS;
}

export type RequestStatusTone = 'success' | 'warning' | 'error' | 'info';

export const REQUEST_STATUS_VISUAL_MAP: Record<string, { tone: RequestStatusTone }> = {
  RECEIVED: { tone: 'info' },
  PROCESSING: { tone: 'warning' },
  COMPLETED: { tone: 'success' },
  COMPLETED_WITH_ERRORS: { tone: 'error' },
  PROCESSED: { tone: 'success' },
  PARTIALLY_PROCESSED: { tone: 'error' },
  SUCCESS: { tone: 'success' },
  ERROR: { tone: 'error' },
};

/** @deprecated Use resolveMonitoringApiBase(processType) */
export const INTEGRATION_MONITORING_API_BASE = '/statement';

export const MONITORING_API_BASE_BY_PROCESS: Record<string, string> = {
  COPARTICIPATION: '/statement',
  CADASTRAL_POSITION: '/beneficiary',
};

export function resolveMonitoringApiBase(processType: string): string {
  return MONITORING_API_BASE_BY_PROCESS[processType] ?? INTEGRATION_MONITORING_API_BASE;
}

export const MONITORING_INDICATORS_PATH = '/v1/internal/monitoring/indicators';

const MONITORING_LIST_PATH_BY_PROCESS: Record<string, string> = {
  COPARTICIPATION: '/v1/internal/monitoring/batches',
  CADASTRAL_POSITION: '/v1/internal/monitoring/requests',
};

/** @deprecated Use resolveMonitoringListPath(processType) */
export const MONITORING_ENDPOINTS = {
  indicators: MONITORING_INDICATORS_PATH,
  list: MONITORING_LIST_PATH_BY_PROCESS.COPARTICIPATION,
};

export function resolveMonitoringListPath(processType: string): string {
  return MONITORING_LIST_PATH_BY_PROCESS[processType] ?? MONITORING_LIST_PATH_BY_PROCESS.COPARTICIPATION;
}

export function resolveMonitoringExportPath(processType: string, rowId: string): string {
  return `${resolveMonitoringListPath(processType)}/${rowId}/export`;
}
